import { useAppDisplayModeContext } from '@archipro-design/aria';
import type { ProfessionalDetailsTestimonial } from '@modules/professional/component/about-tab/testimonial/Testimonials.mobile';
import { TestimonialsMobile } from '@modules/professional/component/about-tab/testimonial/Testimonials.mobile';
import { TestimonialsDesktop } from '@modules/professional/component/about-tab/testimonial/Testimonials.desktop';
import React from 'react';

export const Testimonials: React.FC<{
    testimonials: ProfessionalDetailsTestimonial[];
}> = ({ testimonials }) => {
    const { mobile } = useAppDisplayModeContext();

    if (mobile) {
        return <TestimonialsMobile professionalTestimonials={testimonials} />;
    }

    return <TestimonialsDesktop professionalTestimonials={testimonials} />;
};
